import React from 'react';
import PropTypes from 'prop-types';

const DistortionDisplayName = ({ distortion: { displayName }, isActive }) => (
  <>
    <span style={{ color: isActive ? '#34a835' : '#e91224' }}>
      <i className="pi pi-star" />
      {displayName}
    </span>
  </>
);

DistortionDisplayName.propTypes = {
  isActive: PropTypes.bool.isRequired,
  displayName: PropTypes.string.isRequired,
  distortion: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DistortionDisplayName;
